import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AlertController, Platform, ViewController} from 'ionic-angular';
import {ReducceService} from '../../shared/services/reducce.service';
import {ReducceTopService} from '../../shared/services/reducce-top.service';
import {ParamCeRepositoryService} from '../../shared/services/repository/symfony-api';
import {CeContextService} from '../../shared/services/context';
import {SiteService} from '../../shared/services/site.service';
import {forkJoin} from 'rxjs/observable/forkJoin';


@Component({
  selector: 'core-sous-genre-top-modal',
  templateUrl: './sous-genre-top-modal.component.html'
})
export class SousGenreTopModalComponent implements OnInit,OnChanges, OnDestroy {

  @Input() openedId: number;
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();
  public loading: boolean = false;
  public sendLoader: boolean = false;
  public reducceTopParSite: boolean;
  public tops = [];
  public sites = [];
  public allSite: boolean | string = true;
  private backbuttonSubscription: any;

  public constructor(private paramCeRepositoryService: ParamCeRepositoryService, private ceContext: CeContextService,
                     public reducceTopService: ReducceTopService, private alertCtrl: AlertController,
                     private siteService: SiteService, private platform: Platform, public viewCtrl: ViewController) {
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    const c = changes.openedId.currentValue;
    if (c) {
      this.backbuttonSubscription = this.platform.registerBackButtonAction(() => {
        this.dismiss();
      });
      this.loading = true;
      this.tops = [];
      this.allSite = true;
      this.paramCeRepositoryService.getParamCeByCeId(this.ceContext.get().id).subscribe(res1 => {
        this.reducceTopParSite = res1.reducceTopParSite;
        const calls = [];
        calls.push(this.reducceTopService.getTop(c));
        if (this.reducceTopParSite) {
          calls.push(this.siteService.getSites());
        }

        forkJoin(calls).subscribe(res => {
            if (this.reducceTopParSite) {
              this.sites =  Object.assign([], res[1]);
              const tops = Object.assign([], res[0]).map(item => {
                return {sousgenres: this.openedId, top: item.top, site: item.site ? item.site.id : null}
              });
              const t = tops.find(item => !item.hasOwnProperty('site') || item.site == null);

              if (tops.length == 0) {
                this.allSite = true;
                this.tops.push({sousgenres: this.openedId, top: 0})
              } else if (!!t) {
                this.allSite = true;
                this.tops.push(t);
              } else {
                this.allSite = false;
                this.tops.push({sousgenres: this.openedId, top: 0})
              }

              this.sites.forEach(item => {
                const t = tops.find(top => top.site == item.id);
                if (t) {
                  this.tops.push(t)
                } else {
                  this.tops.push({sousgenres: this.openedId, top: 0, site: item.id})
                }
              });
            } else {
              const tops = Object.assign([], res[0]).map(item => {
                return {sousgenres: this.openedId, top: item.top, site: item.site ? item.site.id : null}
              });
              const t = tops.find(item => !item.hasOwnProperty('site') || item.site == null);
              if (t) {
                this.tops = tops;
              } else {
                this.tops.push({sousgenres: this.openedId, top: 0})
              }
            }
            this.loading = false;
          }, error => {
            this.loading = false;
          });
        }, error => {
          this.loading = false;
        }
      )
    }
  }

  valid() {
    this.sendLoader = true;
    const tops = this.getTops(!(this.allSite == true || this.allSite == 'true'));
    this.reducceTopService.updateTop(tops).subscribe(res => {
      this.sendLoader = false;
      this.close();
    }, error => {
      this.sendLoader = false;
      this.close();
    })
  }

  close() {
    this.destroySubscription();
    this.closeEmitter.emit('close');
  }

  dismiss() {
    this.destroySubscription();
    this.closeEmitter.emit('dismiss');
  }

  destroySubscription() {
    if (this.backbuttonSubscription) {
      this.backbuttonSubscription();
    }
  }


  getTops(sites: boolean) {
    return this.tops.filter(item => sites ? (item.hasOwnProperty('site')  && item.site != null) : (!item.hasOwnProperty('site') || item.site == null))
  }

  findSiteName(siteId) {
    const s = this.sites.find(item => item.id === siteId);
    return s ? s.nom : '';
  }

  getMarginStyle(index) {
    if (index == 1) {
      return {'margin-left': '0px'};
    } else if (index == 3 ) {
      return {'margin-right' : '0px'};
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/sous-genre-top-modal/sous-genre-top-modal.component.ts